import { render, staticRenderFns } from "./PatientChart.vue?vue&type=template&id=c37712f0"
import script from "./PatientChart.vue?vue&type=script&lang=ts"
export * from "./PatientChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports